/* Getting back to the Hird Hub.
 *
 * Blueprint is reached from a Hub tile and opens as its own site, exactly as
 * SignIn does — so it needs the same way out, and for the same reason: with
 * no control in the app, the browser Back button is the only exit and the app
 * reads as a dead end.
 *
 * Deliberately a copy of hird-signin/src/core/hub.ts rather than a shared
 * package. It is two constants and a click handler, and @hird/ui exists for
 * things with a rendering contract; a pinned package for this would cost more
 * to keep in step than it saves.
 */

/** Where the Hub lives. Also the referrer we check for on the way back. */
export const HUB_URL = 'https://hub.hird.co.uk';

/**
 * Whether a plain click should step back through history instead of
 * navigating.
 *
 * Both routes land on the hub, but a back step restores the page the browser
 * already has — instantly, as it was left, with no reload and no splash.
 * Navigating throws that away and rebuilds it from nothing. Only when the
 * person actually arrived from the hub; anyone who opened Blueprint directly
 * has nothing behind them, and the href is their route.
 *
 * Modified clicks are the browser's to handle, not ours: middle-click and
 * ctrl-click should still open the hub in a new tab.
 */
export function shouldStepBack(e: {
  metaKey: boolean; ctrlKey: boolean; shiftKey: boolean; button: number;
}): boolean {
  const plain = !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0;
  return plain
    && document.referrer.startsWith(HUB_URL)
    && window.history.length > 1;
}
